<template>
    <div v-if="loading" class="loading-container">
    <img src="../../assets/fonts/loadingNine.gif" alt="loading">
  </div>
  <div v-else class="quickLogin-container">
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      loading: true // 控制加载状态
    }
  },
  created() {
    // localStorage.clear() //跳转登录进来后清除所有缓存
    const { token, isLoginByInter, redirectUrl } = this.$route.query
    console.log(token, isLoginByInter, redirectUrl, 'token,isLoginByInter,redirectUrl')
    if (isLoginByInter) {
      localStorage.setItem('isLoginByInter', isLoginByInter)
      console.log('isLoginByInter：已缓存')
    } else {
      localStorage.setItem('isLoginByInter', '0')
      console.log('isLoginByInter：缓存为0')
    }

    if (redirectUrl) {
      localStorage.setItem('redirectUrl', redirectUrl)
      console.log('redirectUrl：已缓存')
    } else {
      localStorage.removeItem('redirectUrl')
      console.log('redirectUrl：缓存已删除')
    }
    console.log('是否缓存成功isLoginByInter', localStorage.getItem('isLoginByInter'))
      console.log('是否缓存成功redirectUrl', localStorage.getItem('redirectUrl'))
    setTimeout(() => {
      console.log('1是否缓存成功isLoginByInter', localStorage.getItem('isLoginByInter'))
      console.log('1是否缓存成功redirectUrl', localStorage.getItem('redirectUrl'))
    }, 3000)
    if (token) {
      this.axios
        .get(`/sys/login/quick?token=${token}`)
        .then((res) => {
          if (res.result.userInfo && res.result.token) {
            let userInfo = res.result.userInfo
            userInfo.eduHomeUrl = res.result.eduHomeUrl || null
            userInfo.eduLogo = res.result.eduLogo || null
            localStorage.removeItem('WEAK_PASSWORD')
            // 登陆成功拿homeObj
            this.axios.get(`/biz/home/param`).then(res => {
              if (res.code === 200) {
                // this.homeObj = res.result
                // console.log(this.homeObj,'header')
                this.$store.state.homeObj = res.result
                localStorage.setItem('homeObj', JSON.stringify(res.result))
                console.log(this.$store.state.homeObj, 'Vuex')
              }
            })


            if (this.$route.query.redirect) {
              const redirect = this.$route.query.redirect
              let str = decodeURI(redirect)
              this.common.loginSuccess(res.result.token, userInfo, str)
            } else {
              this.common.loginSuccess(res.result.token, userInfo)
            }

          } else {
            this.loading = false
            this.title = `此次登录失败，请关闭页面后请重试`
          }
        })
        .catch(() => {
          this.loading = false
          this.title = `此次登录失败，请关闭页面后请重试`
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.quickLogin-container {
  text-align: center;
  padding: 100px;
  font-size: 30px;
}


.loading-container {
  background-color:#fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 或者其他适合的高度 */
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/quickLogin.vue